import {WishlistIconName} from './iconNames';

import assetIcEmptyWishlistCompact from './assets/ic-empty-wishlist-compact.svg';
import assetIcEmptyWishlist from './assets/ic-empty-wishlist.svg';
export const wishlistPageIconAssets = {
  [WishlistIconName.Empty]: assetIcEmptyWishlist,
  [WishlistIconName.EmptyCompact]: assetIcEmptyWishlistCompact,
};
